/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Toggle_SidebarInputs */



/**
* | output |
* | --- |
* | "Toggle sidebar" |
*
* @param {Layout_Toggle_SidebarInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_toggle_sidebar = /** @type {((inputs?: Layout_Toggle_SidebarInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Toggle_SidebarInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seitenleiste umschalten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher ou masquer le panneau")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("切换侧边栏")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("切換側邊欄")
	if (locale === "ko") return /** @type {LocalizedString} */ ("사이드바 전환")
	return /** @type {LocalizedString} */ ("Toggle sidebar")
});